import { PackageIcon } from '@phosphor-icons/react';
import { getOptimizedSquareImage } from './helpers';

type GroupImageProps = {
  title: string;
  imageUrl?: string;
};

const GroupImage = ({ title, imageUrl }: GroupImageProps) =>
  imageUrl ? (
    <img
      alt={title}
      src={getOptimizedSquareImage(imageUrl, 320)}
      className="aspect-2/3 w-18 rounded-lg border border-border object-cover"
    />
  ) : (
    <div className="flex h-14 w-14 items-center justify-center rounded-xl border border-border bg-muted/40 text-muted-foreground">
      <PackageIcon size={18} />
    </div>
  );

export default GroupImage;
